export enum AI {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=367451929
     */
    PROMPT_TIPS = 'WREX_AI.GENERATE_CONTENT_TIPS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=367453535
     */
    PROMPT_TIPS_KEYWORDS = 'WREX_AI.GENERATE_CONTENT_TIPS_2',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=367460206
     */
    PROMPT_TIPS_QUESTIONS = 'WREX_AI.GENERATE_CONTENT_TIPS_3',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=546988623
     */
    AUTHORIZATION_ERROR_WARNING = 'ASK_AI.AUTHORIZATION_ERROR_WARNING',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=548679960
     */
    AUTHORIZATION_SUCCESS_MESSAGE = 'ASK_AI.AUTHORIZATION_SUCCESS_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=534611171
     */
    GOOD_RESPONSE = 'ASK_AI.GOOD_RESPONSE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=460866431
     */
    BAD_RESPONSE = 'ASK_LUMAPPS.BAD_RESPONSE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=536209051
     */
    FEEDBACK_REASON_INCORRECT = 'ASK_AI.FEEDBACK_REASON_INCORRECT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=536209057
     */
    FEEDBACK_REASON_IRRELEVANT = 'ASK_AI.FEEDBACK_REASON_IRRELEVANT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=535804465
     */
    FEEDBACK_SENT = 'ASK_AI.FEEDBACK_SENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=563181188
     */
    HOW_CAN_ANSWER_BE_IMPROVED = 'ASK_AI.HOW_CAN_ANSWER_BE_IMPROVED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=563179654
     */
    HOW_DESCRIBE_ANSWER = 'ASK_AI.HOW_DESCRIBE_ANSWER',
}
